import React, {useMemo, useRef, useState} from 'react';
import {Dialog, DialogBackdrop, DialogPanel, DialogTitle} from "@headlessui/react";
import {FaTimes} from "react-icons/fa";
import {AgGridReact} from "ag-grid-react";
import {LocalizationAgGrid} from "../utils/localization-ag-grid";
import SshService from "../services/ssh-service";

const SshModal = ({open, set, project}) => {
    const [columnDefs] = useState([
        {field: "name", headerName: "Nome"},
        {field: "ip", headerName: "IP:Porta"},
        {
            field: "is_main",
            headerName: "Principal",
            sortable: false,
            width: 80,
            cellClass: "justify-center ag-ssh-disabled-checkbox",
        },
        {field: "type", headerName: "Tipo de conexão", flex: 1, minWidth: 250},
    ]);

    const gridRef = useRef();

    const defaultColDef = useMemo(() => ({resizable: false}), []);

    const onCellClicked = ({data: {id}}) => {
        SshService.openSshConnection(project?.value ?? project?.id, id);
    };

    return (
        <Dialog open={open} onClose={set} className="relative z-50">
            <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-700 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 w-full lg:w-10/12 overflow-y-auto m-auto">
                <div className="flex lg:min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <DialogPanel
                        transition
                        className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 w-9/12 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                    >
                        <div className="bg-white py-4 border-b border-gray-300">
                            <div className="text-left">
                                <DialogTitle as="h3"
                                             className="font-semibold leading-6 border-b border-gray-300 px-3 flex justify-between">
                                    Acesso SSH aos servidores
                                    <span onClick={() => set(false)} className="cursor-pointer">
                                        <FaTimes/>
                                    </span>
                                </DialogTitle>
                                <div className="mt-4 px-3">
                                    <div className={"ag-theme-quartz grid mt-4"}
                                         style={{height: "calc(100vh - 233px)"}}>
                                        <AgGridReact
                                            ref={gridRef}
                                            rowHeight={32}
                                            rowData={project?.ssh ?? []}
                                            columnDefs={columnDefs}
                                            defaultColDef={defaultColDef}
                                            animateRows={false}
                                            suppressRowClickSelection={true}
                                            suppressCellFocus={true}
                                            onCellClicked={onCellClicked}
                                            gridOptions={{localeText: LocalizationAgGrid}}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </DialogPanel>
                </div>
            </div>
        </Dialog>
    );
};

export default SshModal;